<template>
  <div>
    <el-col :xs="24" :lg="24" :md="24" :sm="24">
      <div class="ticket-container">
        <div class="ticket-wrapper">
          <div class="select-group">
            <div>
              <el-select style="width:110px" v-model="newMonitor.shipping_type" class="mobile-select" placeholder="物流类型">
                <el-option v-for="(p, index) in shipping_types" :key="index" :label="p.value"
                  :value="p.id"></el-option>
              </el-select>
            </div>
            <div>
              <el-select style="width:200px;"
                          v-model="newMonitor.shipping_company_id"
                          clearable
                          filterable
                          :filter-method="remotetransportSearch"
                          class="input-width"
                          placeholder="物流公司">
                          <el-option
                            v-for="item in remoteTrasports"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id"></el-option>
          </el-select>
            </div>
            <div>
              <el-input class="commbo-input" style="width:130px;"
                v-model="newMonitor.shipping_number" placeholder="物流单号">              
              </el-input>
            </div>
            <div>
              <el-input class="commbo-input" style="width:130px;"
                v-model="newMonitor.shipping_link" placeholder="物流链接">              
              </el-input>
            </div>
          </div>
          <div class="select-group" style="margin-top:20px;">
            <div>
              <el-select style="width:110px" v-model="newMonitor.monitor_flag" class="mobile-select" placeholder="监控开关">
                <el-option v-for="(p, index) in monitor_flags" :key="index" :label="p.value"
                  :value="p.id"></el-option>
              </el-select>
            </div>
            <div>
              <el-input class="commbo-input" style="width:130px;"
                v-model="newMonitor.group_tag" placeholder="分组">              
              </el-input>
            </div>
            <div>
              <el-select style="width:110px" v-model="newMonitor.monitor_type" class="mobile-select" placeholder="监控类型">
                <el-option v-for="(p, index) in monitor_types" :key="index" :label="p.value"
                  :value="p.id"></el-option>
              </el-select>
            </div>
            <div>
              <el-input class="commbo-input" style="width:130px;"
                v-model="newMonitor.monitor_keyword" placeholder="监控关键字">              
              </el-input>
            </div>
          </div>
        </div>
          <div class="select-group" style="margin:20px 0;">
            <div style="width:30%;display: flex;align-items: center;">
                  <el-input style="width:80%" v-model="newMonitor.related_task_id" placeholder="任务号"></el-input>                 
            </div>
            <div style="width:30%;display: flex;align-items: center;">
                  <el-select style="width:80%;" v-model="newMonitor.related_merchant_id" clearable filterable :filter-method="filterSearch"
          class="combo-right input-width" placeholder="商家">
          <el-option v-for="item in merchantOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
        </el-select>
            </div>
            <div>
              <el-date-picker v-model="newMonitor.monitor_start_time" type="datetime" placeholder="监控开始时间"></el-date-picker>
            </div>
          </div>
          <!--<div class="select-group" style="margin-top:20px;">
            <div style="width:48%;display: flex;align-items: center;">
                  <div style="width:70px;margin-right:10px;">关联商家:</div>
                  <el-select style="width:70%;" v-model="newTicket.merchant_id" clearable filterable :filter-method="filterSearch"
                    class="input-width" placeholder="商家">
                    <el-option v-for="item in merchantOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
                  </el-select>                
            </div>
            <div style="width:52%;display: flex;align-items: center;">
                  <div style="width:70px;margin-right:10px;">关联转运:</div>
                  <el-select style="width:calc(100% - 80px)"
                          v-model="newTicket.transport_company_id"
                          clearable
                          filterable
                          :filter-method="remotetransportSearch"
                          class="input-width"
                          placeholder="转运公司">
                          <el-option
                            v-for="item in remoteTrasports"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id"></el-option>
                  </el-select>
            </div>
          </div>-->
      </div>
    </el-col>
    <div v-if="mode=='createNew'">
      <el-button :loading="isSubmitting" class="block" type="primary" @click="submit">提 交</el-button>
    </div>
  </div>
</template>

<script>
import Order from '../list/Order'
import { API_HOST, FILE_HOST,SPEC_MAPPER } from '../../../services/constant.js'
import api from '../../../services/api.js'
let _ = require('lodash')

export default {
  name: 'OrderList',
  props:['r','mode','ticketStatus','ticketPriorities','singleList'
  ,'ticketTypes','ticketVisible','merchants','expressList','exceptionTypes'],
  components: {
    Order:Order
  },
  data() {
    return {
      contenteditmode:{
        topic:false,
        description:false,
        scope:false,
      },
      replyDisabled:false,
      replycontent:'',
      replyVisible:'',
      isSubmitting:false,
      merchantOptions:[],
      remoteTrasports:[],
      shipping_types:[{id:1,value:'商家物流'},{id:2,value:'转运物流'},{id:3,value:'终端物流'}],
      monitor_flags:[{id:1,value:'开启'},{id:0,value:'关闭'}],
      monitor_types:[{id:1,value:'物流进展'},{id:2,value:'包裹揽收'}],
      newMonitor:{
        shipping_type:'',
        shipping_company_id:'',
        shipping_number:'',
        shipping_link:'',
        related_merchant_id:'',
        related_task_id:'',
        monitor_flag:'',
        group_tag:'',
        monitor_type:'',
        monitor_start_time:'',
        monitor_keyword:''
      }
    }
  },
  async mounted() {
    
  },
  methods: {
    submit(){
      this.$emit('submit',this.newMonitor)
    },
    remotetransportSearch(queryString,callback){
      this.remoteTrasports=[]
      let res=this.expressList.filter((i)=>{
        return i.name.toLowerCase().indexOf(queryString.toLowerCase())>-1
      })
      _.each(res,item => {
        if(item.type == '2') {
          this.remoteTrasports.push({value:item.name,id:item.id})
        }
      })
      if(callback)
          callback()
    },
    filterSearch(val) {
      this.merchantOptions = []
      let mers = [];
      if (val) {
        mers = this.merchants.filter((item) => {
          return item.merchant_name.toLowerCase().indexOf(val.toLowerCase()) > -1
        })
      }
      else {
        mers = this.merchants;
      }
      mers.forEach(item => {
        this.merchantOptions.push({ value: item.merchant_name, id: item.merchant_id })
      })
    },
    handle(c){
      c.editMode=!c.editMode
      this.$forceUpdate()
    },
    commentVisible(visible_range_id){
      let single_type=this.$localStorage.get('single_type')
      let role=this.$localStorage.get("role")
      switch(visible_range_id){
        case '1':
          return true;
        case '2':
          if(single_type=='1')
            return true
          else
            return false;
        case '3':
          if(role=='0')
            return false
          else
            return true
      }
      return false
    },
    setReplyVisible(data){
      this.replyVisible=data
    },
    generateDateDisplay(datestring){
      let today=new Date()
      let yesterday=new Date(today.getTime() -24*60*60*1000)
      let today_string=this.$moment(today).format('YYYY-MM-DD')
      let yest_string=this.$moment(yesterday).format('YYYY-MM-DD')
      if(datestring==today_string)
        return '今天';
      if(datestring==yest_string)
        return '昨天';
      return datestring
    },
    handleReplySelect(key){
      let arr = key.split('-')
      let status=arr.length>2?arr[2]:arr[1]
      this.replyHandler(status)
    },
    async replyHandler(status){
      if(!this.replycontent)
        return
      this.replyDisabled = true
      let params = {}
      params.visible_range_id=this.replyVisible;
      params.content=this.replycontent
      params.status_id=status || this.r.status_id
      params.ticket_id=this.r.id
      let res = await api.replyTicket(this,params)
      if(res.body.status=='ok'){
        this.replycontent=''
        let reply = res.body.result
        reply.replyDateDisplay=this.generateDateDisplay(reply.replied_date.split(' ')[0])
        reply.replyTimeDisplay=reply.replied_date.split(' ')[1]
        this.r.comments.push(reply)
        this.replyDisabled = false
      }
    },
    handleTopicBlur(){
      this.contenteditmode.topic=false
      if(this.mode!='createNew')
        api.updateTicket(this,{id:this.r.id,subject:this.r.subject})
    },
    handleAssignToSelect(index){
      let arr = index.split('-')
      this.r.assigned_to_group=arr[1]
      this.r.assigned_to=arr[2]
      if(this.mode!='createNew')
        api.updateTicket(this,{id:this.r.id,assigned_to_group:this.r.assigned_to_group,assigned_to:this.r.assigned_to})
      else{
        this.newTicket.assigned_to_group=this.r.assigned_to_group
        this.newTicket.assigned_to=this.r.assigned_to
      }
    },
    handleTypeSelect(e){
      let arr = e.split('-')
      this.r.type_id=arr.length>2?arr[2]:arr[1]
      if(this.mode!='createNew')
        api.updateTicket(this,{id:this.r.id,type_id:this.r.type_id})
      else
        this.newTicket.type_id=this.r.type_id
    },
    handlePrioritySelect(e){
      let arr = e.split('-')
      this.r.priority_id=arr[1]
      if(this.mode!='createNew')
        api.updateTicket(this,{id:this.r.id,priority_id:this.r.priority_id})
      else
        this.newTicket.priority_id=this.r.priority_id
    },
    handleReplyVisibleSelect(e){
      let arr = e.split('-')
      this.replyVisible=arr[1]
    },
    handleVisibleSelect(e){
      let arr = e.split('-')
      this.r.visible_range_id=arr[1]
      this.replyVisible=this.r.visible_range_id
      if(this.mode!='createNew')
        api.updateTicket(this,{id:this.r.id,visible_range_id:this.r.visible_range_id})
      else
        this.newTicket.visible_range_id=this.r.visible_range_id
    },
    handleVisibleSelectComment(e,comment){
      let arr = e.split('-')
      comment.visible_range_id=arr[1]
      api.updateComment(this,{id:comment.id,visible_range_id:comment.visible_range_id})
      this.$forceUpdate()
    },
    handlerTopic(){
      this.contenteditmode.topic=true
      this.$nextTick(()=>{
        this.$refs.subject.focus()
      })
    },
    handlerScope(){
      this.contenteditmode.scope=true
      this.$nextTick(()=>{
        this.$refs.scope.focus()
      })
    },
    handlerTextarea(){
      if(this.r.description)
        this.r.description = this.r.description.replace(/\n/g, '<br>')
      this.contenteditmode.description=false
      if(this.mode!='createNew')
        api.updateTicket(this,{id:this.r.id,description:this.r.description})
    },
    handler2Textarea(){
      if(this.r.description)
        this.r.description = this.r.description.replace(/<br>/g, '\n')
      this.contenteditmode.description=true
      this.$nextTick(()=>{
        this.$refs.description.focus()
      })
    },
    async updateMail(index){
      this.$emit('updateMail',index)
    },   
  }
}
</script>

<style lang="scss" scoped>
  .select-group{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .tag-label{
    background:black;
    color:white;
    display: inline-block;
    height: 30px;
    padding: 0 5px;
    border-radius: 5px;
    line-height: 30px;
  }
  .progress-row{
    display:flex;
  }
  .progress{
    .progress-row{
      padding:15px 0;
      border-top:1px solid #DCDFE6;
    }
  }
  .content-group{
    margin:20px 0 0;   
  }
  .content-editable{
      border:1px solid transparent;
      border-radius: 4px;
      min-height: 40px;     
      display:block;
      cursor: pointer;
      .editIcon {
        cursor: pointer;
        display: none;
        background: url('../../../ico/el-icon-editcopy@2x.png');
        background-size: cover;
        position:relative;
        top:2px;
      }
      &.input{
        line-height: 40px;
        height:40px;
      }
      &.textarea{
        line-height: 1.5;
        min-height: 21px;
      }
      &:hover{
        .editIcon{
          display: inline-block;
        }
      }
    } 
  .info{
    margin-bottom: 10px;
  }
  .content_link{
    color:#303133;
  }
.ticket-container{
      padding:15px 0;
      &:first-child{
        padding-top:0;
      }
      &:last-child{
        padding-bottom:0;
        border-bottom:none;
      }
      &.order{
        display: flex;
        justify-content: space-between;
      }
    }
.ticket-wrapper{
      .product-wrapper-left.lika{
        margin-left:237px;
        &.taskDisplay{
          margin-left:200px;
        }
      }
      .product-wrapper-right{
        text-align:right;
      }
      &:last-child{
        margin-bottom:0;
      }
      &.order{
        flex:1;
        border-right: 1px solid #D7D7D7;
        padding-right: 25px;
        line-height:1;
      }
      .product-wrapper-right.order p{
        color:#888888;
      }
    }
    .product-item{
      display:flex;
      height:120px;
      margin-bottom:30px;
      &:first-child{
        padding-top:0;
      }
      &:last-child{
        border-bottom:0;
        padding-bottom: 0;
        margin-bottom:0;
      }
      .product-detail{
          display:flex;
          flex-direction:column;
          justify-content:space-between;
          flex:1;
          position:relative;
          top:-3px;
          margin-left:20px;
          .product-name{
            font-size: 14px;
            color: #333333;
          }
          .product-price{
            line-height: 32px;
            color: black;
            label{
              font-size: 18px;
            }
          }
          .product-price del{
            font-size: 16px;
          }
      }
    }
  .product-price label.danger{
    font-size: 18px;
    color:#FF4650;
  }

  .priority-label{
    display: inline-block;
    width:16px;
    height:16px;
    border-radius: 2px;
    position: relative;
    top:1px;
    &.P1{
      background-color: #FF4650;
    }
    &.P2{
      background-color: #e6a23c;
    }
    &.P3{
      background-color: #409eff;
    }
    &.P4{
      background-color: #909399;
    }
  }
  .comment-status-row{
    display:flex;
    align-items: center;
    padding-bottom: 5px;
    line-height:25px;
    .visible-view{
      display: inline-block;
    }
    .visible-edit{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/monitor/MonitorBody.vue